import { render, staticRenderFns } from "./ViewResponseDetail.vue?vue&type=template&id=1982aaa6"
import script from "./ViewResponseDetail.vue?vue&type=script&lang=js"
export * from "./ViewResponseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports